import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\public\\assets\\alstone_logo.svg");
;
import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\public\\assets\\background\\renewable-second.webp");
;
import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\public\\assets\\background\\renewable.webp");
;
import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\public\\assets\\emerge-red-block.webp");
;
import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\public\\assets\\logo-transparent.webp");
;
import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\public\\assets\\renewables-logo.svg");
